import {ArrowBack} from "@mui/icons-material";
import {Fab} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {AppRoutes} from "../../Router";
import './Catalog.scss';
import {WLOCreditAPIService} from "../../services";
import {useCallback, useEffect, useState} from "react";
import {useIntl} from "react-intl";
import ClockLoader from "react-spinners/ClockLoader";
import {useLoginContext} from "../../hooks/useLoginContext";
import {useRequestContext} from "../../hooks/useRequestContext";
import ResponsiveAppBar from "../../components/shared/Menubar/ResponsiveAppBar";

interface CatalogProps {
}

export function Catalog(_props: CatalogProps) {
    const {user} = useLoginContext();
    const {setRequest} = useRequestContext();
    const [isLoading, setIsLoading] = useState(false);
    const [inventarioWLO, setInventarioWLO] = useState({} as any);
    const intl = useIntl();
    const navigate = useNavigate();

    const handleSubmit = () => {
        if (user.istipo === "2") {
            navigate(AppRoutes.LOGINAUTO, {replace: true});
        } else {
            navigate(AppRoutes.MENU_USER, {replace: true});
        }
    };

    const handleSubmitCredit = (name: any, price: any, imagen: any, codProduct: any) => {
        localStorage.removeItem('person');
        localStorage.removeItem('personaValidada');
        localStorage.removeItem('codeudor');
        setRequest({
            searchANI: false,
            errorConsulta: false,
            nameProduct: name,
            priceProduct: price,
            codProduct,
            imagemoto: imagen,
        });
        navigate(AppRoutes.HOME, {replace: true});
    };

    const getInfoProductos = useCallback(async (data: any) => {
        const requestData = {
            ...data,
            pws_cate_producto: data.pws_cate_producto === "-1" ? "" : data.pws_cate_producto,
        };

        const result = await WLOCreditAPIService.getInventario(requestData);
        const products = result.payload?.data?.RespProd?.RespuestaProd;

        if (!products || products.length === 0) {
            setInventarioWLO(null);
            return;
        }

        setInventarioWLO(result.payload.data);
    }, []);

    const fechInventary = useCallback(async () => {
        setIsLoading(true);

        try {
            await WLOCreditAPIService.getInventario({
                pws_tip_producto: "1",
                pws_cod_producto: "",
                pws_cate_producto: "",
            });

            await getInfoProductos({
                pws_tip_producto: "",
                pws_cod_producto: "",
                pws_cate_producto: "",
            });
        } catch (error) {
            console.log(error);
            setInventarioWLO(null);
        } finally {
            setIsLoading(false);
        }
    }, [getInfoProductos]);

    useEffect(() => {
        fechInventary();
    }, [fechInventary]);

    const renderInventaryLocal = () => {
        if (isLoading) {
            return <div className="catalog-empty-state">Cargando</div>;
        }

        const products = inventarioWLO?.RespProd?.RespuestaProd ?? [];

        if (products.length === 0) {
            return <div className="catalog-empty-state">No hay productos para mostrar</div>;
        }

        return products.map((valor: any) => (
            <button
                type="button"
                key={valor.R_s_cod_prod}
                className="catalog-product-card"
                onClick={() => handleSubmitCredit(valor.R_s_nom_prod, valor.R_s_precio_comer, valor.R_s_link_img, valor.R_s_cod_prod)}
            >
                <span className="catalog-product-image">
                    <img src={valor.R_s_link_img} alt={valor.R_s_nom_prod}/>
                </span>
                <span className="catalog-product-title">{valor.R_s_nom_prod}</span>
                <span className="catalog-product-action">Iniciar solicitud</span>
            </button>
        ));
    };

    return (
        <div className="catalog-page">
            <ResponsiveAppBar/>
            <ClockLoader id="spinner" color={"#4FAE32"} loading={isLoading} size={100}/>

            <main className="catalog-main">
                <div className="catalog-toolbar">
                    <Fab
                        variant="extended"
                        color="neutral"
                        aria-label={intl.formatMessage({id: "button_back"})}
                        onClick={handleSubmit}
                        className="catalog-back-button hooverButtonRed"
                    >
                        <ArrowBack sx={{mr: 1}} className="hooverButtonRedsvg"/>
                        {intl.formatMessage({id: "button_back"})}
                    </Fab>
                </div>

                <section className="catalog-content" aria-labelledby="catalog-title">
                    <div className="catalog-header">
                        <h1 id="catalog-title" className="title-motos-catalog">{intl.formatMessage({id: "motorcycles"})}</h1>
                        <p className="subtitle-motos-catalog">{intl.formatMessage({id: "choose_the_one_of_your_preference"})}</p>
                    </div>

                    <div className="catalog-panel">
                        <div className="catalog-grid">
                            {renderInventaryLocal()}
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}
